import { action, makeObservable, observable } from 'mobx';
import type { IViewPortOrientation } from '../interfaces';
import type { IThreeDViewPortDetails } from './viewEntity/view.entity.ts';

export class ViewPort3DDetails implements IThreeDViewPortDetails {
  @observable public orientation: IViewPortOrientation;

  public frontOrientationDescriptor: string;

  public constructor(orientation: IViewPortOrientation, frontOrientationDescriptor: string) {
    this.orientation = orientation;
    this.frontOrientationDescriptor = frontOrientationDescriptor;
    makeObservable(this);
  }

  @action
  public setOrientation(orientation: IViewPortOrientation): void {
    this.orientation = orientation;
  }
}
